export const PLAN_RESTRICTIONS = {
  //Location data management
  CAN_MANAGE_LOCATION_DATA: "can_manage_location_data",
  //Location data protection
  CAN_PROTECT_LOCATION_DATA: "can_protect_location_data",
  //Marketing publications (posts, offers)
  CAN_PUBLISH_MARKETING_PUBLICATIONS: "can_publish_marketing_publications",
  //Automatic publication of scheduled posts and offers
  CAN_PLAN_MARKETING_PUBLICATIONS: "can_plan_marketing_publications",
  //Photo publication
  CAN_POST_PHOTOS: "can_post_photos",
  //Replying to reviews (manually)
  CAN_REPLY_TO_REVIEWS_MANUALLY: "can_reply_to_reviews_manually",
  //Replying to reviews (templates)
  CAN_USE_REVIEW_TEMPLATES: "can_use_review_templates",
  //Replying to reviews (AI)
  CAN_USE_AI_REVIEW_REPLY: "can_use_ai_review_reply",
  //AI review categorization (without sentiment and without analytics)
  CAN_USE_AI_REVIEWS_CATEGORIZATION: "can_use_ai_reviews_categorization",
  //Sentiment analysis (and analytics)
  CAN_USE_SENTIMENT_ANALYSIS: "can_use_sentiment_analysis",
  //Manual sentiment assignment
  CAN_MANUALLY_ADD_SENTIMENT: "can_manually_add_sentiment",
  //AI assessment of customer photos
  CAN_VERIFY_MEDIA_BY_AI: "can_verify_media_by_ai",
  //Rating monitoring and reports
  CAN_MONITOR_RATINGS_AND_REPORTS: "can_monitor_ratings_and_reports",
  //Monitoring and reports of user actions in GM
  CAN_MONITOR_GMB_ACTIONS_AND_REPORTS: "can_monitor_gmb_actions_and_reports",
  //SEO analysis - positions in local search results
  CAN_VIEW_SEO_LOCAL_SEARCH_POSITIONS: "can_view_seo_local_search_positions",
  //SEO analysis - competition comparison
  CAN_COMPARE_COMPETITION: "can_compare_competition",
  //Tutorials
  CAN_VIEW_TUTORIALS: "can_view_tutorials",
  //Bing Maps integration
  CAN_ENABLE_BING_MAPS: "can_enable_bing_maps",
  CAN_USE_Q_AND_A: "can_use_q_and_a",
  //Automatic review replies
  CAN_USE_REVIEW_AUTO_REPLIES: "can_use_review_auto_replies",
  //Mobile app integration
  CAN_USE_MOBILE_PLATFORMS_INTEGRATION: "can_use_mobile_platforms_integration"
};
